import { useState } from 'react';
import './index.css';

// 初始化默认信息
const defaultProfile = {
  avatar: "https://cdn-icons-png.flaticon.com/512/149/149071.png",
  nickname: "请编辑昵称",
  intro: "这个人很神秘，什么也没留下。",
  blogIntro: "欢迎来到我的博客！请您点击完善您的个人信息！",
  email: "请填写邮箱",
  techStack: "暂无",
  interests: "暂无"
};

const About = () => {
  // 从本地存储读取个人信息
  const [profile, setProfile] = useState(() => {
    const saved = localStorage.getItem('blogProfile');
    return saved ? JSON.parse(saved) : defaultProfile;
  });
  // 控制编辑弹窗显示/隐藏
  const [isEditing, setIsEditing] = useState(false);
  // 编辑表单的临时数据
  const [formData, setFormData] = useState(profile);

  // 输入框变化时更新临时表单
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // 保存编辑并同步到本地存储
  const handleSave = () => {
    setProfile(formData);
    localStorage.setItem('blogProfile', JSON.stringify(formData));
    setIsEditing(false);
    // 触发storage事件，让Header同步更新
    window.dispatchEvent(new Event('storage'));
  };

  return (
    <div className="about-container">
      {/* 信息展示区（不可修改） */}
      <div className="profile-card">
        <div className="avatar-wrapper">
          <img src={profile.avatar} alt="用户头像" className="avatar" />
        </div>
        <h2 className="nickname">Hi，我是{profile.nickname}！</h2>
        <p className="user-intro">{profile.intro}</p>
        <p className="blog-intro">{profile.blogIntro}</p>

        {/* 信息列表 */}
        <div className="info-list">
          <div className="info-item">
            <span className="label">邮箱</span>
            <span className="value">{profile.email}</span>
          </div>
          <div className="info-item">
            <span className="label">技术栈</span>
            <span className="value">{profile.techStack}</span>
          </div>
          <div className="info-item">
            <span className="label">兴趣爱好</span>
            <span className="value">{profile.interests}</span>
          </div>
        </div>

        {/* 编辑按钮 */}
        <button className="edit-btn" onClick={() => setIsEditing(true)}>
          编辑个人信息
        </button>
      </div>

      {/* 编辑弹窗（默认隐藏） */}
      {isEditing && (
        <div className="modal-overlay">
          <div className="edit-modal">
            <h3 className="modal-title">编辑个人信息</h3>
            <div className="form-group">
              <label>头像URL</label>
              <input
                type="text"
                name="avatar"
                value={formData.avatar}
                onChange={handleInputChange}
                placeholder="输入图片链接"
              />
            </div>
            <div className="form-group required">
              <label>昵称 *</label>
              <input
                type="text"
                name="nickname"
                value={formData.nickname}
                onChange={handleInputChange}
                placeholder="请输入昵称"
                required
              />
            </div>
            <div className="form-group required">
              <label>个人简介 *</label>
              <textarea
                name="intro"
                value={formData.intro}
                onChange={handleInputChange}
                rows={2}
                placeholder="请输入个人简介"
                required
              />
            </div>
            <div className="form-group required">
              <label>博客介绍 *</label>
              <textarea
                name="blogIntro"
                value={formData.blogIntro}
                onChange={handleInputChange}
                rows={2}
                placeholder="请输入博客介绍"
                required
              />
            </div>
            <div className="form-group">
              <label>联系邮箱</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="请输入邮箱"
              />
            </div>
            <div className="form-group">
              <label>技术栈</label>
              <input
                type="text"
                name="techStack"
                value={formData.techStack}
                onChange={handleInputChange}
                placeholder="请输入技术栈"
              />
            </div>
            <div className="form-group">
              <label>兴趣爱好</label>
              <input
                type="text"
                name="interests"
                value={formData.interests}
                onChange={handleInputChange}
                placeholder="请输入兴趣爱好"
              />
            </div>
            <div className="btn-group">
              <button className="cancel-btn" onClick={() => setIsEditing(false)}>
                取消
              </button>
              <button className="save-btn" onClick={handleSave}>
                保存
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default About;